module.exports = __webpack_public_path__ + "static/media/8.8607c913.jpeg";